(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["inverawe-foodhall-range"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', (event) => {
    const select = event.target;
    if (!select.matches('[data-foodhall-sort] select[name="sort_by"]')) return;
    const destination = new URL(window.location.href);
    destination.searchParams.set('sort_by', select.value);
    destination.searchParams.delete('page');
    destination.hash = 'christmas-food-hall';
    window.location.assign(destination.href);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["inverawe-mobile-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('inverawe-mobile-products')) {
  customElements.define('inverawe-mobile-products', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.media = window.matchMedia('(max-width: 749px)');
      this.mobileOpen = false;
      this.mobileMode = undefined;
      this.onModeChange = () => this.updateMode();
      this.onToggle = () => {
        if (this.mobileMode) this.mobileOpen = this.details.open;
      };
      this.updateMode();
      this.media.addEventListener('change', this.onModeChange);
      this.details.addEventListener('toggle', this.onToggle);
    }

    disconnectedCallback() {
      this.media.removeEventListener('change', this.onModeChange);
      this.details.removeEventListener('toggle', this.onToggle);
    }

    updateMode() {
      const mobile = this.media.matches;
      if (mobile === this.mobileMode) return;
      if (this.mobileMode) this.mobileOpen = this.details.open;
      this.mobileMode = mobile;
      this.details.open = mobile ? this.mobileOpen : true;
    }

    reveal() {
      this.details.open = true;
      if (this.mobileMode) this.mobileOpen = true;
    }
  });

  function revealAutumnProducts(hash, focus, smooth) {
    if (!hash || !hash.startsWith('#')) return false;
    const target = document.getElementById(hash.slice(1));
    const group = target && target.querySelector('inverawe-mobile-products');
    if (!group) return false;
    group.reveal();
    if (focus) {
      const heading = group.mobileMode ? group.querySelector('summary') : group.querySelector('.aw-mobile-products__content h2');
      if (heading) {
        if (heading.tagName !== 'SUMMARY') heading.setAttribute('tabindex', '-1');
        heading.focus({preventScroll:true});
      }
    }
    window.scrollTo({
      top:Math.max(0, target.getBoundingClientRect().top + window.scrollY - 24),
      behavior:smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'auto'
    });
    return true;
  }

  document.addEventListener('click', (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href^="#"]');
    if (!link) return;
    const hash = link.getAttribute('href');
    if (!revealAutumnProducts(hash, true, true)) return;
    event.preventDefault();
    window.history.replaceState(window.history.state, '', hash);
  });

  const revealCurrentHash = () => requestAnimationFrame(() => revealAutumnProducts(window.location.hash, false, false));
  window.addEventListener('hashchange', revealCurrentHash);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', revealCurrentHash, {once:true});
  else revealCurrentHash();
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["inverawe-pate-campaign-card"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('.christmas-home__campaign-form')) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button.disabled) return;
    const card = form.closest('.christmas-home__campaign-card');
    const status = card.querySelector('[role="status"]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    status.textContent = '';
    try {
      const response = await fetch(`${form.action.replace(/\/$/, '')}.js`, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || status.dataset.error);
      status.textContent = button.dataset.addedLabel;
      card.querySelector('.christmas-home__campaign-bag').hidden = false;
      fetch(`${form.action.replace(/\/cart\/add\/?$/, '/cart')}.js`, { headers: { Accept: 'application/json' } })
        .then((cartResponse) => cartResponse.ok ? cartResponse.json() : null)
        .then((cart) => {
          if (!cart) return;
          document.querySelectorAll('.fairytale__utilities a[href$="/cart"]').forEach((link) => {
            let count = link.querySelector('span');
            if (!count) {
              count = document.createElement('span');
              link.append(count);
            }
            count.textContent = cart.item_count;
          });
        })
        .catch(() => {});
    } catch (error) {
      status.textContent = error.message || status.dataset.error;
    } finally {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["inverawe-quick-add"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('inverawe-quick-add')) {
  let autumnCartQueue = Promise.resolve();
  customElements.define('inverawe-quick-add', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.form = this.querySelector('form');
      this.button = this.querySelector('button[type="submit"]');
      this.feedback = this.querySelector('.aw-quick-add__feedback');
      this.quantity = this.form.querySelector('[name="quantity"]');
      this.quantityButtons = this.querySelectorAll('[data-quantity-change]');
      this.available = !this.button.disabled;
      this.quantityButtons.forEach((button) => button.addEventListener('click', () => {
        if (this.pending || !this.available) return;
        if (!this.quantity.value) this.quantity.value = this.quantity.min;
        if (button.dataset.quantityChange === '1') this.quantity.stepUp();
        else this.quantity.stepDown();
        this.updateQuantityButtons();
      }));
      this.quantity.addEventListener('input', () => this.updateQuantityButtons());
      this.quantity.addEventListener('change', () => {
        const value = Number(this.quantity.value);
        const maximum = this.quantity.max ? Number(this.quantity.max) : Infinity;
        this.quantity.value = String(Math.min(maximum, Math.max(1, Math.floor(value) || 1)));
        this.updateQuantityButtons();
      });
      this.updateQuantityButtons();
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        if (this.pending || this.button.disabled) return;
        const formData = new FormData(this.form);
        this.pending = true;
        this.button.disabled = true;
        this.quantity.disabled = true;
        this.updateQuantityButtons();
        this.button.setAttribute('aria-busy', 'true');
        this.feedback.hidden = true;
        autumnCartQueue = autumnCartQueue.catch(() => {}).then(() => this.addToBag(formData));
      });
    }

    updateQuantityButtons() {
      const value = Number(this.quantity.value);
      this.quantityButtons.forEach((button) => {
        const atLimit = button.dataset.quantityChange === '-1' ? value <= 1 : this.quantity.max && value >= Number(this.quantity.max);
        button.disabled = this.pending || !this.available || Boolean(atLimit);
      });
    }

    async addToBag(formData) {
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      let added = false;
      try {
        const sectionIds = cart ? cart.getSectionsToRender().map((section) => section.id) : ['cart-icon-bubble'];
        formData.append('sections', sectionIds.join(','));
        formData.append('sections_url', window.location.pathname);
        const endpoint = new URL(this.form.action);
        if (!endpoint.pathname.endsWith('.js')) endpoint.pathname += '.js';
        const response = await fetch(endpoint, {method:'POST', headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}, body:formData});
        const result = await response.json();
        if (!response.ok || result.status) {
          this.showFeedback(typeof result.description === 'string' ? result.description : this.dataset.error);
          return;
        }
        added = true;
        const bubble = document.getElementById('cart-icon-bubble');
        const bubbleHtml = result.sections && result.sections['cart-icon-bubble'];
        if (bubble && bubbleHtml) {
          const updated = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
          if (updated) bubble.innerHTML = updated.innerHTML;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {source:'inverawe-quick-add',productVariantId:formData.get('id'),cartData:result});
        }
        this.showFeedback(this.dataset.added);
        if (cart) {
          cart.classList.remove('is-empty');
          cart.setActiveElement(this.button);
          cart.renderContents(result);
        }
      } catch (error) {
        this.showFeedback(added ? this.dataset.added : this.dataset.error);
      } finally {
        this.pending = false;
        this.button.disabled = false;
        this.quantity.disabled = false;
        this.updateQuantityButtons();
        this.button.removeAttribute('aria-busy');
      }
    }

    showFeedback(message) {
      this.feedback.querySelector('span').textContent = message;
      this.feedback.hidden = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
